import classNames from 'classnames';
import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import ReactMarkdown from 'react-markdown';

import { EventsState } from '../../../../store/types';
import { TemplateClassNames, TemplateNames } from '../../../../types/template-layouts';
import { Registration } from '../../../../types/working-model';
import { getStartTime } from '../../../../utils/get-event-start-time';
import { getTextValue } from '../../../../utils/utils';
import { TypographyItem } from '../../../general-ui/typography-item/typography-item';
import { ParamsProps } from '../../live-event';
import { getAsset } from '../../modules/assets/asset-map';
import { getStylingOverrides } from '../../utils';
import './registration-layout.scss';

interface Props {
	registration: Registration;
	startDate?: Date;
	template: TemplateNames;
	children: ReactNode;
}

export const RegistrationLayout = ({
	children,
	startDate,
	template,
	registration,
}: Props): JSX.Element => {
	const {
		LiveEventReducer: {
			eventBundle
		},
		CreateEventReducer: {
			previewMode,
			workingEvent
		}
	} = useSelector((state: EventsState) => state);

	const { language }: ParamsProps = useParams();

	const styling_overrides = registration.style?.styling_overrides;
	// const { t } = useTranslation('homepage');

	const isPreview = previewMode === 'registration';

	const startsOnText = isPreview ? (workingEvent ? String(getStartTime(workingEvent!, true)) : null) : (eventBundle ? String(getStartTime(eventBundle!, true)) : null);

	const registrationStyle = registration.style;
	const registrationLayout = registrationStyle?.layout || 'form-right';


	const {
		backgroundColor,
		// backgroundImg,
		titleOverrides,
		descriptionOverrides,
	} = getStylingOverrides(styling_overrides);

	const templateClass = TemplateClassNames[template];

	const { title, description } = getTextValue(registration, language);

	return (
		<section
			className={classNames(
				`registration ${registrationLayout}`,
				templateClass,
				backgroundColor
			)}
		>
			<div
				className="registration-heading-container"
				style={{ backgroundImage: `url(${registration.image ? registration.image : getAsset(template, 'registration_header')})` }}
			>
				<div className="registration-start-time">
					<div className="registration-start-time-date">
						<TypographyItem className="evt-caption-2 month">
							{startDate?.toLocaleString('default', { month: 'short' })}
						</TypographyItem>
						<TypographyItem className={classNames('stable', {
							'evt-heading-4': template === TemplateNames.Apollo,
							'evt-heading-5': template !== TemplateNames.Apollo,
						})}>
							{startDate?.toLocaleString('default', { day: 'numeric' })}
						</TypographyItem>
					</div>
					<TypographyItem className="registration-start-time-title evt-caption-1" tagName="time" dateTime={startDate?.toISOString()}>
						{startsOnText}
					</TypographyItem>
				</div>
				<TypographyItem className={classNames('evt-heading-2 registration-title', titleOverrides)} tagName="h1">
					{title}
				</TypographyItem>
				<TypographyItem className='evt-body-text-1'>
					<ReactMarkdown
						source={description}
						className={classNames('registration-description', descriptionOverrides)}
					/>
				</TypographyItem>
			</div>
			<div className="registration-form-container">{children}</div>
		</section>
	);
};
